import { ROUTES } from '@/routes/paths';

/** Ссылка на карточку сделки (/app/deals/:dealId). */
export function makeDealUrl(dealId: number): string {
  return `${ROUTES.APP_DEALS}/${dealId}`;
}
